export const termsOfServiceData = {
  TermsOfService: {
    Heading: "Esquadifi Terms of Service",
    SubHeading: "Effective Date: September 14, 2024",
    Steps: [
      {
        title: "1. General",
        subSteps: [
          {
            subTitle: "A. Legal Agreement",
            subContent: [
              `These Terms of Service (“Terms”) are a legal contract between you ("User") and Squadifi LTD (Company No. 13853322), registered at 1st Floor, 85 Mercian Way, Edgeley, Stockport, SK3 9DF, England. By accessing or using ESquadifi’s platform, participating in esports events, purchasing Tokens, or wagering using Belts, you agree to be bound by these Terms and any relevant policies, including our Privacy Policy, which is incorporated by reference.`,
            ],
          },
          {
            subTitle: "B. Services Provided",
            subContent: [
              "Squadifi provides a multi-functional platform that enables Users to:",
              "Participate in esports tournaments and competitions.",
              "Wager in skill-based competitions using Belts (a virtual currency).",
              "Purchase Tokens for use in wagering, buying tickets, and gifting other users.",
              "Stream live events, purchase tickets for live events, and interact with content through gifting.",
            ],
          },
          {
            subTitle: "C. User Responsibilities",
            subContent: [
              "You are responsible for complying with all applicable laws in your jurisdiction, particularly regarding online esports and wagering. By using Squadifi’s services, you confirm that you meet the legal age requirements to participate in your country, which is 18 or older unless otherwise restricted.",
              "Your use of the platform must not violate local regulations or national laws concerning skill-based competitions, wagering, and online services.",
            ],
          },
        ],
      },
      {
        title: "2. Account Registration",
        subSteps: [
          {
            subTitle: "A. Eligibility",
            subContent: [
              "To create an account, you must be at least 18 years old, provide accurate information during registration, and maintain the confidentiality of your login credentials. Any misuse, unauthorised access, or account transfer is prohibited. Squadifi reserves the right to refuse, suspend, or terminate any account for violating these Terms or engaging in unlawful activities.",
            ],
          },
          {
            subTitle: "B. Account Security",
            subContent: [
              "Users are responsible for the security of their accounts and must notify Squadifi immediately of any unauthorised use or breach of security. Squadifi will not be liable for any losses resulting from unauthorised account access.",
            ],
          },
          {
            subTitle: "C. Account Termination",
            subContent: [
              "We may terminate or suspend your account without notice if you violate these Terms, including fraud, unlawful conduct, or abusive behaviour. Account termination may result in the forfeiture of earnings, tokens, or access to services. Squadifi also reserves the right to terminate inactive accounts after six months of non-use.",
            ],
          },
        ],
      },
      {
        title: "3. Tokens, Belts, and Wagering",
        subSteps: [
          {
            subTitle: "A. Tokens and Belts",
            subContent: [
              "Tokens are the platform’s primary in-game currency and can be purchased using real money. Tokens may be converted into Belts, a secondary virtual currency for skill-based wagering in esports competitions. Belts hold no inherent cash value and cannot be exchanged outside the platform. However, based on your performance in competitions, Belts can be redeemed as earnings.",
            ],
          },
          {
            subTitle: "B. Use of Tokens",
            subContent: [
              "Tokens may be used to:",
              "Convert into Belts for wagering.",
              "Purchase tickets to live events.",
              "Purchase virtual gifts for players, which can be converted into earnings.",
            ],
          },
          {
            subTitle: "C. Wagering and Skill-Based Competitions",
            subContent: [
              "All wagering on the Squadifi platform is skill-based, meaning the outcome of events is determined by the players' abilities, not by chance. This ensures compliance with UK and international gambling laws. Users are responsible for ensuring that skill-based wagering is legal in their jurisdiction.",
            ],
          },
          {
            subTitle: "D. Earnings from Wagering",
            subContent: [
              "Earnings are calculated based on performance in skill-based esports events and other platform activities, such as ticket sales and gifts. Squadifi reserves the right to withhold or deny earnings if fraudulent activity, rule violations, or platform abuse is detected.",
            ],
          },
        ],
      },
      {
        title: "4. Event Participation and Streaming",
        subSteps: [
          {
            subTitle: "A. Skill-Based Competitions",
            subContent: [
              "Participation in Squadifi’s events is strictly skill-based. Users must ensure compliance with local regulations that may apply to skill-based gaming and wagering. Users acknowledge that success in these events depends on their performance.",
            ],
          },
          {
            subTitle: "B. Live Streaming and Gifting",
            subContent: [
              "Squadifi allows users to purchase tickets for live-streamed esports events. Users may also purchase gifts using Tokens, which are converted into earnings for players. Streaming content may be used by Squadifi for promotional purposes without further consent from the User.",
            ],
          },
        ],
      },
      {
        title: "5. Payouts and Redemption",
        subSteps: [
          {
            subTitle: "A. Earnings and Verification",
            subContent: [
              "All earnings from wagers, gifts, and ticket sales are subject to Squadifi’s verification processes, including identity verification and fraud checks. Users may be required to submit additional documentation before payouts can be processed.",
            ],
          },
          {
            subTitle: "B. Withdrawal Process",
            subContent: [
              "Withdrawals of earnings are subject to compliance with identity verification and applicable tax regulations. Squadifi reserves the right to delay or deny withdrawals if there are any concerns related to fraud or legal violations.",
            ],
          },
          {
            subTitle: "C. Taxes",
            subContent: [
              "It is the User’s responsibility to comply with all applicable tax laws, including reporting and paying any taxes on earnings received from the Squadifi platform.",
            ],
          },
        ],
      },
      {
        title: "6. Prohibited Conduct",
        subSteps: [
          {
            subTitle: "A. Fraud and Cheating",
            subContent: [
              "Engaging in fraudulent activities, such as collusion, manipulating competition outcomes, using bots, or exploiting technical loopholes, is strictly prohibited. Any User found to be engaging in such conduct will face account suspension or permanent termination.",
            ],
          },
          {
            subTitle: "B. Unauthorised Software",
            subContent: [
              "The use of unauthorised software or external assistance to manipulate gameplay is forbidden. Violations of this rule will result in immediate account termination and the forfeiture of all earnings.",
            ],
          },
        ],
      },
      {
        title: "7. Privacy and Data Collection",
        content: [
          "Your personal data is collected, used, and protected according to Squadifi’s Privacy Policy. Squadifi collects information for fraud prevention, platform management, and to ensure compliance with legal and regulatory obligations. Data includes information provided during account creation, transaction history, and activity on the platform. Please review the Privacy Policy for more detailed information on how your data is handled.",
        ],
      },
      {
        title: "8. Dispute Resolution",
        subSteps: [
          {
            subTitle: "A. Arbitration and Class Action Waiver",
            subContent: [
              "Any disputes arising out of or related to these Terms will be resolved through binding arbitration in accordance with the laws of England and Wales. Users waive the right to bring or participate in any class action lawsuits or similar legal proceedings against Squadifi.",
            ],
          },
          {
            subTitle: "B. Governing Law and Jurisdiction",
            subContent: [
              "These Terms are governed by and interpreted under the laws of England and Wales. In the event that a dispute is not resolved through arbitration, it shall be subject to the exclusive jurisdiction of the courts of England.",
            ],
          },
        ],
      },
      {
        title: "9. Warranties and Limitation of Liability",
        subSteps: [
          {
            subTitle: "A. No Warranties",
            subContent: [
              "Squadifi provides the platform on an 'as is' and 'as available' basis. We do not warrant that the services will be uninterrupted, secure, or error-free. You acknowledge that your use of the platform is at your own risk.",
            ],
          },
          {
            subTitle: "B. Limitation of Liability",
            subContent: [
              "To the maximum extent permitted by law, Squadifi's liability for any claim arising from your use of the platform is limited to the amount you have paid in Tokens. We are not liable for any indirect, consequential, special, or incidental damages, including lost profits or data.",
            ],
          },
        ],
      },
      {
        title: "10. Changes to the Terms and Services",
        content: [
          "Squadifi reserves the right to modify, suspend, or terminate any aspect of the platform or these Terms at any time. Any changes to the Terms will be posted on our website and will become effective immediately. Continued use of the platform after changes signifies your acceptance of the updated Terms.",
        ],
      },
      {
        title: "11. Contact Information",
        content: [
          "For questions, concerns, or any issues related to these Terms, please contact us:",
          "Squadifi LTD, 1st Floor, 85 Mercian Way, Edgeley, Stockport, SK3 9DF, England",
          "Email: support@esquadifi.io",
        ],
      },
    ],
  },
};
